import { Component, OnInit, ViewChild,Input, Output } from '@angular/core';
import { HTTPClientService } from '../../shared/services/httpclient.service';
import { LanguageService } from '../../shared/services/language.service';

import { AccountService } from '../../shared/services/account.service';
import { AppService } from "../../shared/services/app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { NewsService } from '../../shared/services/news.service';
import { ProductsService } from '../../shared/services/products.service';
import { TranslateService } from '@ngx-translate/core';

declare var $:any; import {isBrowser} from '../../shared/thirdparty/isBrowser'

@Component({
  selector: 'app-waste-management',
  templateUrl: './waste-management.component.html',
  styleUrls: ['./waste-management.component.scss']
})
export class WasteManagementComponent implements OnInit {

  public blocnews = null;
  public listProducts:any = [];
  public ids = [132,92,56];

  public images = [
    {
      url : "assets/logos-sectors/arkema",
      alt : "logo waste management arkema",
      title : "arkema",
    },
    {
      url : "assets/logos-sectors/cea",
      alt : "logo waste management cea",
      title : "cea",
    },
    {
      url : "assets/logos-sectors/edf",
      alt : "logo waste management edf",
      title : "edf",
    },
    {
      url : "assets/logos-sectors/rte",
      alt : "logo waste management rte",
      title : "rte",
    },
    {
      url : "assets/logos-sectors/suez",
      alt : "logo waste management suez",
      title : "suez",
    },
    {
      url : "assets/logos-sectors/veolia",
      alt : "logo waste management veolia",
      title : "veolia",
    },
    {
      url : "assets/logos-sectors/vertex",
      alt : "logo waste management vertex",
      title : "vertex",
    }
  ];


    constructor(
      public accountService : AccountService,
      private productService: ProductsService,
      public newsService: NewsService,
      public language : LanguageService,
      public appService : AppService,
      public router : Router,
      public translate: TranslateService
    ) {}

    ngOnInit(): void {

      this.newsService.getNews(156)
      .then((results)=>{
        this.blocnews = this.newsService.formateOneNews(results);
      })

      this.productService.searchProducts(null, [248], 0, 1000)
      .then((resultats)=>{
        this.listProducts = this.productService.setProductsInfos(resultats["datas"],-1,-1);
      })

    }

}
